import {z} from 'zod';
import { b2bCalendarTimeInterval } from './b2bCalendarTimeInterval';

export const b2bCalendarDay = z.object({
  id: z.coerce.number(),
  day: z.coerce.string(),
  isActive: z.coerce.boolean().default(false),
  b2bCalendarTimeIntervals: z.array(b2bCalendarTimeInterval).nullable(),
});

export type b2bCalendarDay = z.infer<typeof b2bCalendarDay>;



